import produce from 'immer'

import { Types } from './actions'

import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'

var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)
dayjs.locale('pt-br')

export const INITIAL_STATE = {
  loadings: {
    getCampaigns: false,
    getCampaignStoreRules: false,
    getCampaignFields: false
  },
  errors: {
    getCampaigns: false,
    getCampaignStoreRules: false,
    getCampaignFields: false
  },
  campaigns: [],
  campaign: {}
}

export default function campaignReducers (state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case Types.getCampaigns: {
        draft.loadings.getCampaigns = true
        draft.errors.getCampaigns = false

        draft.storeId = action.payload?.storeId || false
        break
      }
      case Types.updateCampaigns: {
        draft.loadings.getCampaigns = false

        draft.campaigns = action?.payload?.campaigns || []
        draft.errors.getCampaigns = action.payload?.error || false
        break
      }
      case Types.updateCampaign: {
        draft.campaign = action.payload?.campaign || {}
        break
      }
      case Types.getCampaignStoreRules: {
        draft.loadings.getCampaignStoreRules = true
        draft.errors.getCampaignStoreRules = false
        break
      }
      case Types.updateCampaignStoreRules: {
        draft.loadings.getCampaignStoreRules = false
        draft.errors.getCampaigns = action.payload?.error || false

        const { storeRules } = action.payload

        if (storeRules && storeRules.length > 0) {
          draft.campaign = { ...state.campaign, ...{ storeRules } }
        }
        break
      }
      case Types.reset: {
        Object.keys(INITIAL_STATE).forEach(key => {
          draft[key] = INITIAL_STATE[key]
        })
        break
      }
      case Types.getCampaignFields: {
        draft.loadings.getCampaignFields = true
        draft.errors.getCampaignFields = false
        break
      }
      case Types.updateCampaignFields: {
        draft.loadings.getCampaignFields = false
        draft.errors.getCampaignFields = action.payload?.error || false

        const { fields = [] } = action.payload

        draft.campaign = { ...state.campaign, ...{ fields } }
        break
      }
      default:
    }
  })
}
